import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class AlertHelperService {
  constructor() {}

  scrollToAlert() {
    const errorElement: HTMLElement =
      document.getElementById('page-heading') ||
      (document.getElementsByClassName('card') != null && (document.getElementsByClassName('card')[0] as HTMLElement));

    if (errorElement) {
      setTimeout(() => {
        errorElement.scrollIntoView({ behavior: 'smooth' });
      }, 100);
    }
  }
}
